import React from 'react';

const DesignButton = (props) => {
  function Navigate() {
    props.context.navigateTo(props.headerButtonLink.value);
  }

  var designModeNumber = -1;
  var designText = 'להצטרפות';

  if (props.blockButton.expandedValue[0]!=null) {
    designText = (props.blockButton.expandedValue[0] as any).text.value;
    designModeNumber = (props.blockButton.expandedValue[0] as any).buttonDesignMode.value;
  }

  const getButtonClassByName = (designIndex) => {
    let name = '';
    switch (designIndex) {
      case 0:
        name = 'purple-button';
        break;
      case 1:
        name = 'black-button';
        break;
      case 2:
        name = 'white-button';
        break;
      case -1:
        name = 'DesignButton__button-container__button';
    }
  
    return name;
  };

  return (
    
    <>
      <div className='DesignButton'>
        <div className='DesignButton__button-container'>
          <a className={`DesignButton__button-container__button ${getButtonClassByName(designModeNumber)}`} href='#' onClick={Navigate} > {designText}
          </a>
        </div>
      </div>
    </>
    
  );
  
};

export default DesignButton;
